export default "__VITE_ASSET__QorSUZtG__"